import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-roaster-construction',
  templateUrl: './roaster-construction.component.html',
  styleUrls: ['./roaster-construction.component.scss']
})
export class RoasterConstructionComponent implements OnInit {
  mydata = [];
  common_rank_id = 3; // change it to zero
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<RoasterConstructionComponent>) {
    Object.keys(data.constrctor_data).forEach((key) => {
        this.mydata.push({'key':key,'value':data.constrctor_data[key]});
    });
    this.common_rank_id = data.common_rank_id;
    }

  ngOnInit() {}

  saveConstrct(formData){
    const postData ={'common_rank_id':this.common_rank_id,'data':formData};
    this.dialogRef.close(postData);
  }
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
